const phases = [
  { name: 'New Moon', illumination: 0 },
  { name: 'Waxing Crescent', illumination: 0.25 },
  { name: 'First Quarter', illumination: 0.5 },
  { name: 'Waxing Gibbous', illumination: 0.75 },
  { name: 'Full Moon', illumination: 1.0 },
  { name: 'Waning Gibbous', illumination: 0.75 },
  { name: 'Last Quarter', illumination: 0.5 },
  { name: 'Waning Crescent', illumination: 0.25 },
];

/**
 * Calculates the current phase of a moon based on the game date.
 * @param gameDate The current date in the game world.
 * @param cycleDays The number of days in the moon's full cycle.
 * @returns The name and illumination percentage of the current phase.
 */
export const calculateMoonPhase = (gameDate: Date, cycleDays: number): { name: string; illumination: number } => {
  const dayOfYear = (Date.UTC(gameDate.getFullYear(), gameDate.getMonth(), gameDate.getDate()) - Date.UTC(gameDate.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;
  const cycleProgress = (dayOfYear % cycleDays) / cycleDays; // value from 0 to 1
  const phaseIndex = Math.floor(cycleProgress * phases.length);
  // The modulo operation guarantees a valid index; use non-null assertion
  // since TypeScript cannot infer the mathematical guarantee
  return phases[phaseIndex % phases.length]!;
};